import React from "react";
import Helmet from 'react-helmet';
import Block from "../../Block";

class CoreHtml extends Block {
  render() {
    const { block } = this.props;
    return null
  }
}

class CoreHtmlFactory {
  get type() {
    return "core/html";
  }

  create(props) {
    return <CoreHtml {...props} />;
  }
}

export default CoreHtmlFactory;
